/* eslint-disable no-unused-vars */
import React from 'react';
import { CheckTreeDividedColumns } from 'assets/icons';
import { Checkbox, ParagraphWithTooltip } from 'components';
import Hightlighter from 'react-highlight-words';
import * as S from './ChildrenRow.styled';

export const ChildrenRow = ({
  label,
  id,
  withShadow,
  searchValue$,
  isSelected,
  toggleSelectedItem,
}) => {
  return (
    <S.Container withShadow={withShadow}>
      <CheckTreeDividedColumns />
      <Checkbox
        id={id}
        isChecked={isSelected(id)}
        name={label}
        style={{ marginRight: '16px' }}
        onChange={() => toggleSelectedItem(id)}
      />
      <div style={{ width: '53%' }}>
        <ParagraphWithTooltip text={label} isHighlight search={searchValue$.value} />
      </div>
    </S.Container>
  );
};
